import ListField from './ListField'
const Reference = props => (
   <ListField
      {...props}
      label="References"
      fieldKey="reference"
      placeholder="Name — Company"
   />
)
export default Reference
